import React from 'react';

const Newsletter = () => (
  <svg
    width="40px"
    height="44px"
    viewBox="0 0 40 44"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Desktop"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="create-account-mobile"
        transform="translate(-827.000000, -278.000000)"
      >
        <g
          id="noun_newsletter_1978589"
          transform="translate(827.000000, 278.000000)"
        >
          <g id="Group">
            <path
              d="M35.1724138,12.99375 L35.1724138,2.0625 C35.1724138,0.89375 34.2068966,0 33.1034483,0 L6.89655172,0 C5.72413793,0 4.82758621,0.9625 4.82758621,2.0625 L4.82758621,12.99375 C0.689655172,17.1875 0.413793103,17.25625 0.482758621,17.6 L0.482758621,17.6 L0.482758621,41.59375 C0.482758621,42.28125 0.75862069,42.9 1.17241379,43.3125 C1.17241379,43.3125 1.17241379,43.3125 1.17241379,43.3125 C1.17241379,43.3125 1.17241379,43.3125 1.17241379,43.3125 C1.5862069,43.725 2.20689655,44 2.89655172,44 L36.9655172,44 C37.6551724,44 38.2758621,43.725 38.6896552,43.3125 C38.6896552,43.3125 38.6896552,43.3125 38.6896552,43.3125 C38.6896552,43.3125 38.6896552,43.3125 38.6896552,43.3125 C39.1034483,42.9 39.3793103,42.28125 39.3793103,41.59375 L39.3793103,17.6 C39.5172414,17.11875 39.4482759,17.325 35.1724138,12.99375 Z M38.137931,41.525 C38.137931,41.525 38.137931,41.59375 38.137931,41.59375 L26.8965517,30.45625 L38.137931,19.25 L38.137931,41.525 Z M37.862069,17.6 L35.1724138,20.2125 L35.1724138,14.91875 L37.862069,17.6 Z M6.89655172,1.375 L33.1034483,1.375 C33.5172414,1.375 33.7931034,1.71875 33.7931034,2.0625 L33.7931034,21.5875 L25.4482759,29.975 C25.4482759,29.975 25.4482759,29.975 25.4482759,29.975 C25.4482759,29.975 25.4482759,29.975 25.4482759,29.975 L20,35.3375 L6.20689655,21.5875 L6.20689655,2.0625 C6.20689655,1.71875 6.48275862,1.375 6.89655172,1.375 Z M1.93103448,41.6625 C1.93103448,41.6625 1.93103448,41.59375 1.93103448,41.59375 L1.93103448,19.25 L13.1034483,30.45625 L1.93103448,41.6625 Z M4.82758621,14.91875 L4.82758621,20.2125 L2.20689655,17.6 L4.82758621,14.91875 Z M2.96551724,42.625 C2.96551724,42.625 2.89655172,42.625 2.89655172,42.625 L14.137931,31.41875 L19.5172414,36.78125 C19.7931034,37.05625 20.2068966,37.05625 20.4827586,36.78125 L25.862069,31.41875 L37.1034483,42.625 C37.1034483,42.625 37.0344828,42.625 37.0344828,42.625 L2.96551724,42.625 Z"
              id="Shape"
              fill="#FFFFFF"
              fillRule="nonzero"
            />
            <path
              d="M9.72413793,20.35 C9.72413793,20.35 9.72413793,20.35 9.72413793,20.35 L30.3448276,20.35 C30.7586207,20.35 31.0344828,20.075 31.0344828,19.6625 C31.0344828,19.25 30.7586207,18.975 30.3448276,18.975 C30.3448276,18.975 30.3448276,18.975 30.3448276,18.975 L9.72413793,18.975 C9.31034483,18.975 9.03448276,19.25 9.03448276,19.6625 C9.03448276,20.075 9.31034483,20.35 9.72413793,20.35 Z"
              id="Path"
              fill="#22D736"
            />
            <path
              d="M9.72413793,5.70625 L30.3448276,5.70625 C30.7586207,5.70625 31.0344828,5.43125 31.0344828,5.01875 C31.0344828,4.60625 30.7586207,4.33125 30.3448276,4.33125 L9.72413793,4.33125 C9.31034483,4.33125 9.03448276,4.60625 9.03448276,5.01875 C9.03448276,5.43125 9.31034483,5.70625 9.72413793,5.70625 Z"
              id="Path"
              fill="#22D736"
            />
            <path
              d="M25.2413793,23.85625 L25.2413793,23.85625 L14.7586207,23.85625 C14.3448276,23.85625 14.0689655,24.13125 14.0689655,24.54375 C14.0689655,24.95625 14.3448276,25.23125 14.7586207,25.23125 L14.7586207,25.23125 L25.2413793,25.23125 C25.6551724,25.23125 25.9310345,24.95625 25.9310345,24.54375 C25.9310345,24.13125 25.5862069,23.85625 25.2413793,23.85625 Z"
              id="Path"
              fill="#22D736"
            />
            <path
              d="M9.72413793,10.5875 L30.3448276,10.5875 C30.7586207,10.5875 31.0344828,10.3125 31.0344828,9.9 C31.0344828,9.4875 30.7586207,9.2125 30.3448276,9.2125 L9.72413793,9.2125 C9.31034483,9.2125 9.03448276,9.4875 9.03448276,9.9 C9.03448276,10.3125 9.31034483,10.5875 9.72413793,10.5875 Z"
              id="Path"
              fill="#22D736"
            />
            <path
              d="M9.72413793,15.46875 L30.3448276,15.46875 C30.7586207,15.46875 31.0344828,15.19375 31.0344828,14.78125 C31.0344828,14.36875 30.7586207,14.09375 30.3448276,14.09375 L9.72413793,14.09375 C9.31034483,14.09375 9.03448276,14.36875 9.03448276,14.78125 C9.03448276,15.19375 9.31034483,15.46875 9.72413793,15.46875 Z"
              id="Path"
              fill="#22D736"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Newsletter;
